import { FILTER_INNOVATION_FIELD, FILTER_PROJECT_STATE, FILTER_TREND_RADAR } from '@/model/innovation-project/filter'
import { EXECUTION, IDEA, IMPLEMENTATION, PREPARATION } from '@/model/innovation-project/states'

export default {
    [FILTER_INNOVATION_FIELD]: {
        label: 'Innovation field'
    },
    [FILTER_PROJECT_STATE]: {
        label: 'Project state'
    },
    [FILTER_TREND_RADAR]: {
        label: 'Trend radar'
    },

    projectStates: {
        [EXECUTION]: 'Excecution',
        [IDEA]: 'Idea',
        [IMPLEMENTATION]: 'Finished',
        [PREPARATION]: 'Preparation'
    }
}
